import BaseApi from "./BaseApi";
import ApiHelper from "../helpers/ApiHelper";
import db from "../resources/db.json";

/**
 * 認証APIクラス
 *
 * @class AuthApi
 * @extends {BaseApi}
 */
class AuthApi extends BaseApi {
  /**
   * ログイン状態を確認する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async auth() {
    return { data: db["auth"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/work-place-list`),
    );
  }
  /**
   * ログインする
   * @param {string} employeeNo 社員番号
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async login(employeeNo) {
    return { data: db["login"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/work-place-list`),
    );
  }
  /**
   * ログアウトする
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async logout() {
    return { data: db["logout"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/work-place-list`),
    );
  }
}
export default AuthApi;
